/* 
COPY AND PAST TEMPLATE

  MISSING: {
    en: "",
    nl: "",
    es: "",
    ca: "",
    eu: "",
    gl: "",
    pt: "",
    fr: "",
    it: "",
    de: ""
  },
*/

export const availableLanguages = [
  { name: "English", code: "en" },
  { name: "Español", code: "es" },
  { name: "Català", code: "ca" },
  { name: "Português", code: "pt" },
  { name: "Nederlands", code: "nl" },
  { name: "Français", code: "fr" },
];

//##################################################
// HEADER - language
//##################################################
/*
 Translations can be prepared for other languages,
 but these are the only ones that are available
 to the user. As we finish translating other
 languages, we will add them. The flag icon would be
 "key.png" (ex. en.png, es.png, ca.png, pt.png, etc)
*/

export const translations = {
  //##################################################
  // HEADER
  //##################################################

  // Error when the conection_token was not found and
  // we can't connect to the event listeners
  listenerError: {
    en: "There is an issue with this agent web and some of its functionalities would be affected. Please contact the support team.",
    nl: "Er is een probleem met deze web medewerker en sommige functies worden hierdoor beïnvloed. Neem contact op met het supportteam.",
    es: "Existe una incidencia con este agente web y algunas funcionalidades se verán afectadas. Por favor contacta con el equipo de soporte.",
    ca: "Existeix una incidència amb l'agent web i algunes de les funcionalitats es poden veure afectades. Si us plau, contacta amb l'equip de suport.",
    eu: "",
    gl: "",
    pt: "Existe uma incidencia com este agente web e algumas das suas funcionalidades não funcionaram corretamente. Por favor contacte com a equipa de suporte.",
    fr: "Un incident avec cet agent internet vient de se produire et certaines fonctionnalités se verront affectées. S'il vous plaît, contactez notre équipe de soutien",
    it: "",
    de: "",
  },
  maxTabError: {
    en: "You've reached the maximum number of tabs opened, close some of them to keep managing calls.",
    nl: "U hebt het maximale aantal geopende tabbladen bereikt. Sluit enkele tabbladen zodat u oproepen kunt blijven beheren.",
    es: "Has llegado al número máximo de pestañas abiertas a la vez, cierra alguna para poder seguir gestionando llamadas.",
    ca: "Has arribat al màxim número de pestanyes obertes, tanca algunes per seguir rebent trucades.",
    eu: "",
    gl: "",
    pt: "Você alcançou o número máximo de abas abertas, feche alguna para continuar gestionando chamadas.",
    fr: "Vous avez atteint le nombre maximum d'onglets ouverts en même temps, fermez-en quelques-uns pour pouvoir continuer à gérer les appels",
    it: "",
    de: "",
  },
  //##################################################
  // HEADER
  //##################################################

  // Header - Search box
  // REPEATED TEXTS: search

  // Header
  availability: {
    en: "Availability",
    nl: "Beschikbaarheid",
    es: "Estado en los servicios",
    ca: "Estat dels serveis",
    eu: "",
    gl: "",
    pt: "Estado nos serviços",
    fr: "État dans les services",
    it: "",
    de: "",
  },
  notifications: {
    en: "Notifications",
    nl: "Meldingen",
    es: "Notificaciones",
    ca: "Notificacions",
    eu: "",
    gl: "",
    pt: "Notificações",
    fr: "Notifications",
    it: "",
    de: "",
  },
  noNotifications: {
    en: "No notifications",
    nl: "Geen meldingen",
    es: "No hay notificaciones",
    ca: "No hi ha notificacions",
    eu: "",
    gl: "",
    pt: "Nenhuma notificação",
    fr: "Pas de notifications",
    it: "",
    de: "",
  },
  missedCall1: {
    en: "Missed call from",
    nl: "Gemiste oproep van",
    es: "Llamada perdida de",
    ca: "Trucada perduda de",
    eu: "",
    gl: "",
    pt: "Ligação perdida de",
    fr: "Appel manqué de",
    it: "",
    de: "",
  },
  missedCall2: {
    en: "on service",
    nl: "in service",
    es: "en el servicio",
    ca: "en el servei",
    eu: "",
    gl: "",
    pt: "no servicio",
    fr: "dans le service",
    it: "",
    de: "",
  },
  logout: {
    en: "Logout",
    nl: "Afmelden",
    es: "Salir",
    ca: "Sortir",
    eu: "",
    gl: "",
    pt: "Logout",
    fr: "Sortir",
    it: "",
    de: "",
  },
  noContactFound: {
    en: "No contacts found",
    nl: "Geen contactpersonen gevonden",
    es: "No se han encontrado contactos",
    ca: "No s'han trobat contactes",
    eu: "",
    gl: "",
    pt: "Nenhum contato encontrado",
    fr: "Contacts non trouvés",
    it: "",
    de: "",
  },

  // Header - Agent's name on click menu
  language: {
    en: "System language",
    nl: "Systeemtaal",
    es: "Idioma del sistema",
    ca: "Idioma del sistema",
    eu: "",
    gl: "",
    pt: "Idioma do sistema",
    fr: "Langue du système",
    it: "",
    de: "",
  },
  personalData: {
    en: "Personal data",
    nl: "Persoonlijke gegevens",
    es: "Datos personales",
    ca: "Dades personals",
    eu: "",
    gl: "",
    pt: "Dados pessoais",
    fr: "Données personnelles",
    it: "",
    de: "",
  },
  callForwardingAndVoiceMail: {
    en: "Call forwarding and voice mail",
    nl: "Doorschakelen en voicemail",
    es: "Desvío y buzón de voz",
    ca: "Desviament i bústia de veu",
    eu: "",
    gl: "",
    pt: "Desvio e correio de voz",
    fr: "Transfert et boîte vocale",
    it: "",
    de: "",
  },
  pageLayout: {
    en: "Page layout",
    nl: "Pagina-indeling",
    es: "Aspecto de la pantalla",
    ca: "Aspecte de la pantalla",
    eu: "",
    gl: "",
    pt: "Layout da página",
    fr: "Aspect de l'ecran",
    it: "",
    de: "",
  },
  changePassword: {
    en: "Change password",
    nl: "Wachtwoord wijzigen",
    es: "Cambiar contraseña",
    ca: "Canviar contrasenya",
    eu: "",
    gl: "",
    pt: "Mudar senha",
    fr: "Changer le mot de passe",
    it: "",
    de: "",
  },
  theme: {
    en: "Theme",
    nl: "Thema",
    es: "Tema",
    ca: "Tema",
    eu: "",
    gl: "",
    pt: "Tema",
    fr: "Thème",
    it: "",
    de: "",
  },
  dark: {
    en: "Dark",
    nl: "Donker",
    es: "Oscuro",
    ca: "Fosc",
    eu: "",
    gl: "",
    pt: "Dark",
    fr: "Sombre",
    it: "",
    de: "",
  },
  default: {
    en: "Default",
    nl: "Standaard",
    es: "Predeterminado",
    ca: "Predeterminat",
    eu: "",
    gl: "",
    pt: "Padrão",
    fr: "Défaut",
    it: "",
    de: ""
  },
  light: {
    en: "Default",
    nl: "Standaard",
    es: "Predeterminado",
    ca: "Predeterminat",
    eu: "",
    gl: "",
    pt: "Padrão",
    fr: "Défaut",
    it: "",
    de: "",
  },
  darkblue: {
    en: "Dark Blue",
    nl: "Donkerblauw",
    es: "Azul oscuro",
    ca: "Blau fosc",
    eu: "",
    gl: "",
    pt: "Azul escuro",
    fr: "Bleu foncé",
    it: "",
    de: "",
  },
  highContrast: {
    en: "High contrast",
    nl: "Hoog contrast",
    es: "Alto contraste",
    ca: "Alt contrast",
    eu: "",
    gl: "",
    pt: "Alto contraste",
    fr: "Contraste élevé",
    it: "",
    de: "",
  },
  //##################################################
  // POPUPS OPENED FROM THE HEADER
  // Popups header have the same name of the link that open them
  //##################################################
  // Language (the content of this popup comes from the availableLanguages array)
  // Personal data
  name: {
    en: "Name",
    nl: "Naam",
    es: "Nombre",
    ca: "Nom",
    eu: "",
    gl: "",
    pt: "Nome",
    fr: "Prénom",
    it: "",
    de: "",
  },
  surname1: {
    en: "Middle surname",
    nl: "Middelste achternaam",
    es: "Primer apellido",
    ca: "Primer cognom",
    eu: "",
    gl: "",
    pt: "Primeiro sobrenome",
    fr: "Premier nom de famille",
    it: "",
    de: "",
  },
  surname2: {
    en: "Last name",
    nl: "Achternaam",
    es: "Segundo apellido",
    ca: "Segon cognom",
    eu: "",
    gl: "",
    pt: "Segundo sobrenome",
    fr: "Second nom de famille",
    it: "",
    de: "",
  },
  address: {
    en: "Address",
    nl: "Adres",
    es: "Dirección",
    ca: "Adreça",
    eu: "",
    gl: "",
    pt: "Endereço",
    fr: "Adresse",
    it: "",
    de: "",
  },
  postalCode: {
    en: "Postal code",
    nl: "Postcode",
    es: "Código postal",
    ca: "Codi postal",
    eu: "",
    gl: "",
    pt: "Código postal",
    fr: "Code postale",
    it: "",
    de: "",
  },
  city: {
    en: "City",
    nl: "Plaats",
    es: "Ciudad",
    ca: "Ciutat",
    eu: "",
    gl: "",
    pt: "Cidade",
    fr: "Ville",
    it: "",
    de: "",
  },
  province: {
    en: "Province",
    nl: "Provincie",
    es: "Provincia",
    ca: "Província",
    eu: "",
    gl: "",
    pt: "Estado",
    fr: "Département",
    it: "",
    de: "",
  },
  phoneNumber1: {
    en: "Phone number",
    nl: "Telefoonnummer",
    es: "Teléfono",
    ca: "Telèfon",
    eu: "",
    gl: "",
    pt: "Telefone",
    fr: "Téléphone",
    it: "",
    de: "",
  },
  phoneNumber2: {
    en: "Mobile number",
    nl: "Mobiel nummer",
    es: "Teléfono móvil",
    ca: "Telèfon mòbil",
    eu: "",
    gl: "",
    pt: "Telemóvel",
    fr: "Téléphone portable",
    it: "",
    de: "",
  },
  email: {
    en: "E-mail",
    nl: "E-mail",
    es: "Correo electrónico",
    ca: "Correu electrònic",
    eu: "",
    gl: "",
    pt: "E-mail",
    fr: "Adresse électronique",
    it: "",
    de: "",
  },
  invalidImageFormat: {
    en: "Please select a valid image.",
    nl: "Selecteer een geldige afbeelding.",
    es: "Por favor, selecciona una imagen válida.",
    ca: "Si us plau, selecciona una imatge vàlida.",
    eu: "",
    gl: "",
    pt: "Selecione uma imagem válida.",
    fr: "S'il vous plaît, choisir une image valide",
    it: "",
    de: "",
  },
  //change password
  oldPass: {
    en: "Current password",
    nl: "Huidig wachtwoord",
    es: "Contraseña actual",
    ca: "Contrasenya actual",
    eu: "",
    gl: "",
    pt: "Senha atual",
    fr: "Mot de passe actuel",
    it: "",
    de: "",
  },
  newPass: {
    en: "New password",
    nl: "Nieuw wachtwoord",
    es: "Nueva contraseña",
    ca: "Nova contrasenya",
    eu: "",
    gl: "",
    pt: "Nova senha",
    fr: "Nouveau mot de passe",
    it: "",
    de: "",
  },
  confirmNewPass: {
    en: "Confirm the new password",
    nl: "Bevestig het nieuwe wachtwoord",
    es: "Repite la nueva contraseña",
    ca: "Repeteix la nova contrasenya",
    eu: "",
    gl: "",
    pt: "Repita sua nova senha",
    fr: "Confirmez le nouveau mot de passe",
    it: "",
    de: "",
  },
  passShouldMatch: {
    en: "Your new password and its confirmation doesn't match.",
    nl: "Uw nieuwe wachtwoord en de bevestiging hiervan komen niet overeen.",
    es: "La nueva contraseña no coincide con su confirmación.",
    ca: "La nova contrasenya no coincideix amb la seva confirmació.",
    eu: "",
    gl: "",
    pt: "Sua nova senha nao coincide con sua confirmação.",
    fr: "Le nouveau mot de passe ne coïncide pas à votre confirmation",
    it: "",
    de: "",
  },
  passChangeError: {
    en: "We couldn't change your password. Make sure your current password is correct.",
    nl: "Uw wachtwoord kon niet worden gewijzigd. Controleer of uw huidige wachtwoord juist is.",
    es: "No se ha podido cambiar la contraseña. Asegúrate de que la contraseña actual es correcta.",
    ca: "No s'ha pogut canviar la contrasenya. Assegura't de que la contrasenya actual és correcta.",
    eu: "",
    gl: "",
    pt: "Não foi possivel alterar su senha. Verifique se sua senha atual é correta.",
    fr: "Le changement de nouveau mot de passe a échoué, Assurez-vous que le mot de passe actuel soit correcte.",
    it: "",
    de: "",
  },
  passLessChars: {
    en: "The password must be at least 8 characters.",
    nl: "",
    es: "La contraseña debe tener al menos 8 caracteres.",
    ca: "La contrassenya ha de tenir almenys 8 caràcters",
    eu: "",
    gl: "",
    pt: "",
    fr: "",
    it: "",
    de: "",
  },
  passwordWeak: {
    en: "Weak password",
    nl: "Zwak wachtwoord",
    es: "Contraseña poco segura",
    eu: "",
    gl: "",
    pt: "Senha fraca",
    ca: "Contrasenya poc segura",
    fr: "Mot de passe faible",
    it: "",
    de: "",
  },
  passwordMedium: {
    en: "Safe password",
    nl: "Veilig wachtwoord",
    es: "Contraseña segura",
    eu: "",
    gl: "",
    pt: "Senha segura",
    ca: "Contrasenya segura",
    fr: "Mot de passe sécurisé",
    it: "",
    de: "",
  },
  passwordStrong: {
    en: "Strong password",
    nl: "Sterk wachtwoord",
    es: "Contraseña muy segura",
    pt: "Senha muito segura",
    eu: "",
    gl: "",
    ca: "Contrasenya molt segura",
    fr: "Mot de passe fort",
    it: "",
    de: "",
  },
  validationCaseType: {
    en: "For more security combine upper and lower case letters",
    nl: "",
    es: "",
    eu: "",
    gl: "",
    pt: "",
    ca: "",
    fr: "",
    it: "",
    de: "",
  },
  validationNumerical: {
    en: "For more security add numerical characters",
    nl: "",
    es: "",
    eu: "",
    gl: "",
    pt: "",
    ca: "",
    fr: "",
    it: "",
    de: "",
  },
  calidationSymbol: {
    en: "For more security add special characters",
    nl: "",
    es: "",
    eu: "",
    gl: "",
    pt: "",
    ca: "",
    fr: "",
    it: "",
    de: "",
  },
  // Call forwarding and voice mail
  alwaysForward: {
    en: "Always forward calls to this number",
    nl: "Schakel oproepen altijd door naar dit nummer",
    es: "Siempre redireccionar las llamadas hacia este número",
    ca: "Sempre redireccionar les trucades cap a aquest número",
    eu: "",
    gl: "",
    pt: "Sempre encaminhar as chamadas para este número",
    fr: "Rediriger automatiquement les appels vers ce numéro",
    it: "",
    de: "",
  },
  ifBusy: {
    en: "When it's busy, forward to this number",
    nl: "Indienbezet, schakel door naar dit nummer",
    es: "Cuando está ocupado, desviar a este número",
    ca: "Quan està ocupat, desviar a aquest número",
    eu: "",
    gl: "",
    pt: "Quando ocupado, desviar a este número",
    fr: "Quand c'est occupé, transférer à ce numero",
    it: "",
    de: "",
  },
  ifNoAsnwserPart1: {
    en: "If doesn't answer in",
    nl: "Bij geen antwoord binnen",
    es: "Si no contesta en",
    ca: "Si no contesta en",
    eu: "",
    gl: "",
    pt: "Se nao atente em",
    fr: "S'il ne répond pas en",
    it: "",
    de: "",
  },
  ifNoAsnwserPart2: {
    en: "seconds, forward to this number",
    nl: "seconden, schakelt u door naar dit nummer",
    es: "segundos, desviar hacia este número",
    ca: "segons, desviar cap a aquest número",
    eu: "",
    gl: "",
    pt: "segundos, desviar para este número",
    fr: "secondes, transférer vers ce numéro",
    it: "",
    de: "",
  },

  // Page layout
  pageLayoutDescription: {
    en: "Enable, disable and sort the modules as you want",
    nl: "Schakel de modules in en uit, en sorteer ze naar wens",
    es: "Activa, desactiva y ordena los módulos como quieras",
    ca: "Activa, desactiva i ordena els mòduls com vulguis",
    eu: "",
    gl: "",
    pt: "Habilita, desabilita e ordena os módulos que queiras",
    fr: "Activer, désactiver et organiser les modules comme vous voulez",
    it: "",
    de: "",
  },

  //##################################################
  // BROWSER AREA (IFRAME)
  //##################################################
  browser: {
    en: "Browser",
    nl: "Browser",
    es: "Navegador",
    ca: "Navegador",
    eu: "",
    gl: "",
    pt: "Navegador",
    fr: "Navigateur",
    it: "",
    de: "",
  },
  browserPlaceholder: {
    en: "Enter web address",
    nl: "Voer webadres in",
    es: "Introduce la dirección web",
    ca: "Introdueix la direcció del web",
    eu: "",
    gl: "",
    pt: "Introduza o endereço web",
    fr: "Introduisez l'adresse électronique",
    it: "",
    de: "",
  },
  more: {
    // Combined tabs name
    en: "More",
    nl: "Meer",
    es: "Más",
    ca: "Més",
    eu: "",
    gl: "",
    pt: "Mais",
    fr: "Plus",
    it: "",
    de: "",
  },
  serviceUrlError: {
    en: "The website URL configured for this service does not allow open it inside other systems. Please contact your supervisor.",
    nl: "De website-URL die is geconfigureerd voor deze service staat opening niet toe binnen andere systemen. Neem contact op met uw supervisor.",
    es: "La página web (URL) configurada para este servicio no permite abrirla dentro de otro sistema. Por favor contacta con tu supervisor.",
    ca: "La pàgina web (URL) configurada per a aquest servei no permet obrir-la dins d'altre sistema. Si us plau contacta amb el teu supervisor.",
    eu: "",
    gl: "",
    pt: "A página web (URL) configurada para este serviço não permite ser aberta dentro de otros sistemas. Por favor contacte tu supervisor.",
    fr: "La page internet (l'URL) configurée pour ce service ne permet pas de l'ouvrir à l'intérieur d'un autre système. S'il vous plaît, contactez votre superviseur.",
    it: "",
    de: "",
  },
  closeAllTabs: {
    en: "Close all tabs",
    nl: "Alle tabbladen sluiten",
    es: "Cerrar todas las pestañas",
    ca: "Tancar totes les pestanyes",
    eu: "",
    gl: "",
    pt: "Fechar todas as abas",
    fr: "Fermez tous les onglets",
    it: "",
    de: "",
  },
  clostOtherTabs: {
    en: "Close other tabs",
    nl: "Andere tabbladen sluiten",
    es: "Cerrar todas las pestañas menos esta",
    ca: "Tancar totes les pestanyes menys aquesta",
    eu: "",
    gl: "",
    pt: "Fechar todas as abas menos esta",
    fr: "Ferme tous les onglets sauf celui-ci",
    it: "",
    de: "",
  },
  closeTab: {
    en: "Close tab",
    nl: "Tabblad sluiten",
    es: "Cerrar pestaña",
    ca: "Tancar aquesta pestanya",
    eu: "",
    gl: "",
    pt: "Fechar aba",
    fr: "Fermer cet onglet",
    it: "",
    de: "",
  },
  omni: {
    en: "Omni",
    nl: "Omni",
    es: "Omni",
    ca: "Omni",
    eu: "",
    gl: "",
    pt: "Omni",
    fr: "Omni",
    it: "",
    de: "",
  },
  //##################################################
  // RIGHT HAND PANELS
  //##################################################
  // TELEPHONY SECTION
  telephony: {
    // Section header's name
    en: "Telephony",
    nl: "Telefonie",
    es: "Telefonía",
    ca: "Telefonia",
    eu: "",
    gl: "",
    pt: "Telefonia",
    fr: "Téléphonie",
    it: "",
    de: "",
  },
  // themepanel: { // Section header's name
  //   en: "Dark Mode",
  //   es: "Dark Mode",
  //   ca: "Dark Mode",
  //   eu: "",
  //   gl: "",
  //   pt: "Dark Mode",
  //   fr: "Dark Mode",
  //   it: "",
  //   de: ""
  // },
  number: {
    // Calling box
    en: "Number",
    nl: "Nummer",
    es: "Número",
    ca: "Número",
    eu: "",
    gl: "",
    pt: "Número",
    fr: "Numéro",
    it: "",
    de: "",
  },
  call: {
    // Call button
    en: "Call",
    nl: "Oproep",
    es: "Llamar",
    ca: "Trucar",
    eu: "",
    gl: "",
    pt: "Chamar",
    fr: "Appeler",
    it: "",
    de: "",
  },
  addressBook: {
    en: "Address book",
    nl: "Adresboek",
    es: "Agenda",
    ca: "Agenda",
    eu: "",
    gl: "",
    pt: "Agenda",
    fr: "Agenda",
    it: "",
    de: "",
  },
  outgoingService: {
    en: "Outgoing service:",
    nl: "Uitgaande service:",
    es: "Llamar por el servicio:",
    ca: "Trucar a través del servei:",
    eu: "",
    gl: "",
    pt: "Chamar pelo serviço:",
    fr: "Appeler pour le service:",
    it: "",
    de: "",
  },
  askBeforeCall: {
    en: "Ask before calling",
    nl: "Vragen alvorens te bellen",
    es: "Preguntar antes de llamar",
    ca: "Preguntar abans de trucar",
    eu: "",
    gl: "",
    pt: "Perguntar altes de chamar",
    fr: "Consulter avant d'appeler",
    it: "",
    de: "",
  },
  selectOutgoingService: {
    en: "Please select the outgoing service you want to use on this call",
    nl: "Selecteer de uitgaande service die u wilt gebruiken voor deze oproep",
    es: "Por favor selecciona el servicio por el cual deseas llamar",
    ca: "Si us plau, selecciona el servei a través del qual vols trucar",
    eu: "",
    gl: "",
    pt: "Por favor selecione o serviço outgoing pelo qual desejas chamar",
    fr: "S'il vous plaît, sélectionnez le service que vous désirez appeler",
    it: "",
    de: "",
  },
  // INCOMING CALLS SECTION
  // REPEATED TEXT: hour, service, phoneNumber, dateAndTime, seeMore, reopenTab, rescheduleCall, businessOutcome, assignToAnotherService
  incomingCalls: {
    // Section name
    en: "Incoming calls",
    nl: "Inkomende oproepen",
    es: "Llamadas entrantes",
    ca: "Trucades entrants",
    eu: "",
    gl: "",
    pt: "Chamadas entrantes",
    fr: "Appels entrants",
    it: "",
    de: "",
  },
  noIncomingCalls: {
    // When there's no incoming calls to list
    en: "No incoming calls",
    nl: "Geen inkomende oproepen",
    es: "No hay llamadas entrantes",
    ca: "No hi ha trucades entrants",
    eu: "",
    gl: "",
    pt: "Não há chamadas entrantes",
    fr: "Pas d'appels entrants",
    it: "",
    de: "",
  },

  // Real time section
  runTime: {
    en: "Runtime",
    nl: "Looptijd",
    es: "Runtime",
    ca: "Runtime",
    eu: "",
    gl: "",
    pt: "Runtime",
    fr: "Runtime",
    it: "",
    de: "",
  },
  ringing: {
    en: "Ringing...",
    nl: "Gaat over…",
    es: "Sonando...",
    ca: "Sonant...",
    eu: "",
    gl: "",
    pt: "Chamando...",
    fr: "En train de sonner...",
    it: "",
    de: "",
  },
  ringingFrom: {
    en: "Ringing from",
    nl: "Gaat over van",
    es: "Sonando desde",
    ca: "Sonant des de",
    eu: "",
    gl: "",
    pt: "Chamando desde",
    fr: "En train de sonner depuis",
    it: "",
    de: "",
  },
  callingTo: {
    en: "Calling to",
    nl: "Bezig met bellen naar",
    es: "Llamando a",
    ca: "Trucant a",
    eu: "",
    gl: "",
    pt: "Chamando a",
    fr: "En train d'appeler à",
    it: "",
    de: "",
  },
  startRecord: {
    en: "Start recording",
    nl: "Opname starten",
    es: "Iniciar grabación",
    ca: "Iniciar gravació",
    eu: "",
    gl: "",
    pt: "Iniciar a gravação",
    fr: "Commencer l'enregistrement",
    it: "",
    de: "",
  },
  stopRecord: {
    en: "Stop recording",
    nl: "Opname stoppen",
    es: "Parar grabación",
    ca: "Parar gravació",
    eu: "",
    gl: "",
    pt: "Parar a gravação",
    fr: "Arrêter l'enregistrement",
    it: "",
    de: "",
  },
  hangupCall: {
    en: "Hang up call",
    nl: "Ophangen",
    es: "Colgar la llamada",
    ca: "Penjar la trucada",
    eu: "",
    gl: "",
    pt: "Desligar chamada",
    fr: "Terminer l'appel",
    it: "",
    de: "",
  },

  // OUTGOING CALLS SECTION
  // MORE TEXTS ON THE REPEATED TEXT SECTIONS AT THE END OF THIS FILE
  outgoingCalls: {
    // Section's name
    en: "Outgoing calls",
    nl: "Uitgaande oproepen",
    es: "Llamadas salientes",
    ca: "Trucades sortints",
    eu: "",
    gl: "",
    pt: "Chamadas outgoing",
    fr: "Appels sortants",
    it: "",
    de: "",
  },
  noOutgoingCalls: {
    // When there's no incoming calls to list
    en: "No outgoing calls",
    nl: "Geen uitgaande oproepen",
    es: "No hay llamadas salientes",
    ca: "No hi ha trucades sortints",
    eu: "",
    gl: "",
    pt: "Não há chamadas outgoing",
    fr: "Pas d'appels sortants",
    it: "",
    de: "",
  },

  // AGENTS SECTIONS
  // REPEATED TEXTS: available, unavailable, oncall
  agents: {
    en: "Agents",
    nl: "Medewerkers",
    es: "Agentes",
    ca: "Agents",
    eu: "",
    gl: "",
    pt: "Agentes",
    fr: "Agents",
    it: "",
    de: "",
  },
  supervisors: {
    en: "Supervisors",
    nl: "Supervisors",
    es: "Supervisores",
    ca: "Supervisors",
    eu: "",
    gl: "",
    pt: "Supervisores",
    fr: "Superviseurs",
    it: "",
    de: "",
  },
  morethan24hr: {
    en: "+24h",
    nl: "+24 u",
    es: "+24h",
    ca: "+24h",
    eu: "",
    gl: "",
    pt: "+24h",
    fr: "+24h",
    it: "",
    de: "",
  },
  // CALL IN QUEUE
  // REPEATED TEXT: service, seeMore
  callsInQueue: {
    // When there are no call in queue
    en: "Queued calls",
    nl: "Oproepen in wachtrij",
    es: "Llamadas en cola",
    ca: "Trucades en cua",
    eu: "",
    gl: "",
    pt: "Chamadas en espera",
    fr: "Appels en attente",
    it: "",
    de: "",
  },
  noCallsInQueue: {
    en: "No calls in queue",
    nl: "Geen oproepen in wachtrij",
    es: "No hay llamadas en cola",
    ca: "No hi ha trucades en cua",
    eu: "",
    gl: "",
    pt: "Sem chamadas em fila",
    fr: "Pas d'appels en attente",
    it: "",
    de: "",
  },
  onQueue: {
    en: "On queue",
    nl: "In wachtrij",
    es: "En cola",
    ca: "En cua",
    eu: "",
    gl: "",
    pt: "Em espera",
    fr: "En attente",
    it: "",
    de: "",
  },
  // List headers
  oldest: {
    en: "Oldest",
    nl: "Oudste",
    es: "Más antigua",
    ca: "Més antiga",
    eu: "",
    gl: "",
    pt: "Mais antiga",
    fr: "Plus ancien",
    it: "",
    de: "",
  },
  noAnswered: {
    en: "No answered",
    nl: "Niet beantwoord",
    es: "No atendidas",
    ca: "No ateses",
    eu: "",
    gl: "",
    pt: "No atendidas",
    fr: "Non répondu",
    it: "",
    de: "",
  },
  queued: {
    en: "Queued",
    nl: "In wachtrij geplaatst",
    es: "En cola",
    ca: "En cua",
    eu: "",
    gl: "",
    pt: "Em espera",
    fr: "En attente",
    it: "",
    de: "",
  },

  // AUTO DIALER
  // TODO - To be defined. What data will be shown here and what are the headers?
  autoDialer: {
    en: "Auto dialer",
    nl: "Automatische kiesfunctie", // Setcion's name
    es: "Automarcador",
    ca: "Automarcador",
    eu: "",
    gl: "",
    pt: "Marcador automático",
    fr: "Automarqueur",
    it: "",
    de: "",
  },
  skipAdmininistrativeTime: {
    en: "Skip administrative time",
    nl: "Beheertijd overslaan",
    es: "Saltar tiempo administrativo",
    ca: "Saltar temps administratiu",
    eu: "",
    gl: "",
    pt: "Saltar tempo administrativo",
    fr: "Sauter le temps administratif",
    it: "",
    de: "",
  },
  getContactImmediately: {
    en: "Get contact immediately",
    nl: "Contactpersoon onmiddellijk ophalen",
    es: "Obtener contacto inmediatamente",
    ca: "Obtenir contacte immediatament",
    eu: "",
    gl: "",
    pt: "Obter contato imediatamente",
    fr: "Obtenir le contact immédiatement",
    it: "",
    de: "",
  },
  noAutoDialerCalls: {
    // When there's no autodialer calls to list
    en: "No auto dialer calls",
    nl: "Geen oproepen met automatische kiesfunctie",
    es: "No hay llamadas de automarcador",
    ca: "No hi ha trucades d'automarcador",
    eu: "",
    gl: "",
    pt: "Não há chamadas do marcador automático",
    fr: "Il n'y a pas d'appels d'automarqueur",
    it: "",
    de: "",
  },
  noScheduledCalls: {
    en: "No scheduled calls",
    nl: "Geen geplande oproepen",
    es: "No hay llamadas programadas",
    ca: "No hi ha trucades programades",
    eu: "",
    gl: "",
    pt: "Não há chamadas programadas",
    fr: "Il n'y a pas d'appels programmés",
    it: "",
    de: "",
  },
  scheduledCalls: {
    en: "Scheduled Calls",
    nl: "Geplande oproepen",
    es: "Llamadas programadas",
    ca: "Trucades programades",
    eu: "",
    gl: "",
    pt: "Chamada programadas",
    fr: "Appels programmés",
    it: "",
    de: "",
  },
  contactId: {
    en: "Contact ID",
    nl: "Contactpersoon-ID",
    es: "ID del contacto",
    ca: "ID del contacte",
    eu: "",
    gl: "",
    pt: "ID do contacto",
    fr: "ID de contact",
    it: "",
    de: "",
  },
  scheduled: {
    en: "Scheduled for",
    nl: "Gepland voor",
    es: "Programado para",
    ca: "Programat per",
    eu: "",
    gl: "",
    pt: "Programado para",
    fr: "Planifié pour",
    it: "",
    de: "",
  },
  list_detail_id: {
    en: "Schedule ID",
    nl: "Plannings-ID",
    es: "ID de programación",
    ca: "ID de programació",
    eu: "",
    gl: "",
    pt: "ID da programação",
    fr: "ID de programmation",
    it: "",
    de: "",
  },
  dateSelectionErrMsg: {
    en: "The start date must be before the end date",
    nl: "De begindatum moet vóór de einddatum liggen",
    es: "La fecha inicial debe ser antes que la fecha final",
    ca: "La data d'inici ha de ser abans de la data de final",
    eu: "",
    gl: "",
    pt: "A data inicial deve ser antes da data final",
    fr: "La date de début doit être antérieure à la date de fin",
    it: "",
    de: "",
  },
  //##################################################
  // REPEATED TEXTS
  //##################################################
  // Popup buttons
  cancel: {
    en: "Cancel",
    nl: "Annuleren",
    es: "Cancelar",
    ca: "Cancel·lar",
    eu: "",
    gl: "",
    pt: "Cancelar",
    fr: "Annuler",
    it: "",
    de: "",
  },
  save: {
    en: "Save",
    nl: "Opslaan",
    es: "Guardar",
    ca: "Desar",
    eu: "",
    gl: "",
    pt: "Salvar",
    fr: "Enregistrer",
    it: "",
    de: "",
  },

  // Incoming and outgoing call options (context menu and see more popup)
  // Calls list headers
  hour: {
    en: "Hour",
    nl: "Uur",
    es: "Hora",
    ca: "Hora",
    eu: "",
    gl: "",
    pt: "Hora",
    fr: "Heure",
    it: "",
    de: "",
  },
  service: {
    en: "Service",
    nl: "Dienst",
    es: "Servicio",
    ca: "Servei",
    eu: "",
    gl: "",
    pt: "Serviço",
    fr: "Service",
    it: "",
    de: "",
  },
  services: {
    en: "Services",
    nl: "Diensten",
    es: "Servicios",
    ca: "Serveis",
    eu: "",
    gl: "",
    pt: "Serviços",
    fr: "Services",
    it: "",
    de: "",
  },
  phoneNumber: {
    en: "Phone",
    nl: "Telefoon",
    es: "Teléfono",
    ca: "Telèfon",
    eu: "",
    gl: "",
    pt: "Teléfone",
    fr: "Téléphone",
    it: "",
    de: "",
  },
  dateAndTime: {
    en: "Date and time",
    nl: "Datum en tijd",
    es: "Fecha y hora",
    ca: "Data i hora",
    eu: "",
    gl: "",
    pt: "Data e hora",
    fr: "Date et l'heure",
    it: "",
    de: "",
  },
  // See more results
  seeMore: {
    en: "See more",
    nl: "Zie meer",
    es: "Ver más",
    ca: "Veure més",
    eu: "",
    gl: "",
    pt: "Ver mais",
    fr: "Voir plus",
    it: "",
    de: "",
  },
  // See more popup header
  region: {
    en: "Region",
    nl: "Regio",
    es: "Provincia",
    ca: "Província",
    eu: "",
    gl: "",
    pt: "Região",
    fr: "Département",
    it: "",
    de: "",
  },
  origin: {
    en: "Region",
    nl: "Regio",
    es: "Provincia",
    ca: "Província",
    eu: "",
    gl: "",
    pt: "Região",
    fr: "Département",
    it: "",
    de: "",
  },
  ring: {
    en: "Ringing",
    nl: "Gaat over",
    es: "Sonando",
    ca: "Sonant",
    eu: "",
    gl: "",
    pt: "Chamando",
    fr: "En train de sonner",
    it: "",
    de: "",
  },
  duration: {
    en: "Duration",
    nl: "Duur",
    es: "Duración",
    ca: "Duració",
    eu: "",
    gl: "",
    pt: "Duração",
    fr: "Durée",
    it: "",
    de: "",
  },
  agentName: {
    en: "Agent name",
    nl: "Naam medewerker",
    es: "Nombre del agente",
    ca: "Nom de l'agent",
    eu: "",
    gl: "",
    pt: "Nome do agente",
    fr: "Nom de l'agent",
    it: "",
    de: "",
  },
  createdDate: {
    en: "Created",
    nl: "Aangemaakt",
    es: "Creado",
    ca: "Creat",
    eu: "",
    gl: "",
    pt: "Criado",
    fr: "Créé",
    it: "",
    de: "",
  },
  assignedDate: {
    en: "Assigned",
    nl: "Toegewezen",
    es: "Asignado",
    ca: "Assignat",
    eu: "",
    gl: "",
    pt: "Atribuído",
    fr: "Attribué",
    it: "",
    de: "",
  },

  // Address book modal
  company: {
    en: "Company",
    nl: "Bedrijf",
    es: "Empresa",
    ca: "Empresa",
    eu: "",
    gl: "",
    pt: "Empresa",
    fr: "Entreprise",
    it: "",
    de: "",
  },
  department: {
    en: "Department",
    nl: "Afdeling",
    es: "Departamento",
    ca: "Departament",
    eu: "",
    gl: "",
    pt: "Departamento",
    fr: "Département",
    it: "",
    de: "",
  },
  position: {
    en: "Position",
    nl: "Positie",
    es: "Puesto",
    ca: "Posició",
    eu: "",
    gl: "",
    pt: "Posição",
    fr: "Poste",
    it: "",
    de: "",
  },
  addresses: {
    en: "Addresses",
    nl: "Adressen",
    es: "Direcciones",
    ca: "Adreces",
    eu: "",
    gl: "",
    pt: "Addresses",
    fr: "Adresse",
    it: "",
    de: "",
  },
  emails: {
    en: "E-mails",
    nl: "E-mails",
    es: "Correos electrónicos",
    ca: "Correus electrònics",
    eu: "",
    gl: "",
    pt: "E-mails",
    fr: "Mail électronique",
    it: "",
    de: "",
  },
  phones: {
    en: "Phones",
    nl: "Telefoons",
    es: "Teléfonos",
    ca: "Telèfons",
    eu: "",
    gl: "",
    pt: "Phones",
    fr: "Téléphones",
    it: "",
    de: "",
  },
  shortNumbers: {
    en: "Short numbers",
    nl: "Verkorte nummers",
    es: "Numeración corta",
    ca: "Numeració curta",
    eu: "",
    gl: "",
    pt: "Short numbers",
    fr: "Numération courte",
    it: "",
    de: "",
  },
  actions: {
    en: "Actions",
    nl: "Acties",
    es: "Acciones",
    ca: "Accions",
    eu: "",
    gl: "",
    pt: "Actions",
    fr: "Actions",
    it: "",
    de: "",
  },

  // Context menu
  reopenTab: {
    en: "Reopen tab",
    nl: "Tabblad opnieuw openen",
    es: "Reabrir pestaña",
    ca: "Reobrir pestanya",
    eu: "",
    gl: "",
    pt: "Reabrir aba",
    fr: "Rouvrir l'onglet",
    it: "",
    de: "",
  },
  rescheduleCall: {
    en: "Reschedule call",
    nl: "Oproep opnieuw plannen",
    es: "Programar llamada",
    ca: "Programar trucada",
    eu: "",
    gl: "",
    pt: "Programar chamada",
    fr: "Programmer les appels",
    it: "",
    de: "",
  },
  noResultsText: {
    en: "No results found",
    nl: "Geen resultaten gevonden",
    es: "Ningún resultado encontrado",
    ca: "Cap resultat trobat",
    eu: "",
    gl: "",
    pt: "Nenhum resultado encontrado",
    fr: "Aucun résultat trouvé",
    it: "",
    de: "",
  },
  businessOutcome: {
    en: "Business outcome",
    nl: "Zakelijk resultaat",
    es: "Final de negocio",
    ca: "Final de negoci",
    eu: "",
    gl: "",
    pt: "Final de negócio",
    fr: "Fin de la négociation",
    it: "",
    de: "",
  },
  tagList: {
    en: "Tag list",
    nl: "Taglijst",
    es: "Lista de etiquetas",
    ca: "Llista d'etiquetes",
    eu: "Etiketa zerrenda",
    gl: "Lista de etiquetas",
    pt: "Lista de etiquetas",
    fr: "Liste des étiquettes",
    it: "Elenco delle etichette",
    de: "Schlagwortliste",
  },
  containsTags: {
    en: "Has tags",
    nl: "Heeft tags",
    es: "Tiene etiquetas",
    ca: "Té etiquetes",
    eu: "Etiketak ditu",
    gl: "Ten etiquetas",
    pt: "Tem etiquetas",
    fr: "A des étiquettes",
    it: "Ha etichette",
    de: "Hat Schlagwörter",
  },

  assignToAnotherService: {
    en: "Assign to another service",
    nl: "Toewijzen aan andere service",
    es: "Asignar a otro servicio",
    ca: "Assignar a un altre servei",
    eu: "",
    gl: "",
    pt: "Atribuir a outro serviço",
    fr: "Attribuer à un autre service",
    it: "",
    de: "",
  },
  assignToAnotherServiceError: {
    en: "Please select the service you want to assign this call to",
    nl: "Selecteer de service die u wilt toewijzen aan deze oproep",
    es: "Por favor selecciona el servicio al cual deseas asignar esta llamada",
    ca: "Si us plau selecciona el servei al que vols assignar aquesta trucada",
    eu: "",
    gl: "",
    pt: "Por favor selecione o serviço no qual desejas associar esta chamada",
    fr: "S'il vous plaît, sélectionnez le service auquel vous désirez attribuer l'appel",
    it: "",
    de: "",
  },
  recording: {
    en: "Recording",
    nl: "Opname",
    es: "Grabación",
    ca: "Enregistrament",
    eu: "",
    gl: "",
    pt: "Gravação",
    fr: "Enregistrement",
    it: "",
    de: "",
  },
  noRecording: {
    en: "No recording available",
    nl: "Geen opname beschikbaar",
    es: "Ninguna grabación disponible",
    ca: "Cap enregistrament disponible",
    eu: "",
    gl: "",
    pt: "Nenhuma gravação disponível",
    fr: "Aucun enregistrement disponible",
    it: "",
    de: "",
  },
  close: {
    en: "Close",
    nl: "Sluiten",
    es: "Cerrar",
    ca: "Tancar",
    eu: "",
    gl: "",
    pt: "Fechar",
    fr: "Fermer",
    it: "",
    de: "",
  },
  // GENERAL TEXTS
  noService: {
    en: "No service",
    nl: "Geen service",
    es: "Sin servicio",
    ca: "Sense servei",
    eu: "",
    gl: "",
    pt: "Sem serviço",
    fr: "Sans service",
    it: "",
    de: "",
  },
  offline: {
    en: "Offline",
    nl: "Offline",
    es: "Desconectado",
    ca: "Desconectat",
    eu: "",
    gl: "",
    pt: "Desligada",
    fr: "Déconnecté",
    it: "",
    de: "",
  },
  time: {
    en: "Time",
    nl: "Tijd",
    es: "Hora",
    ca: "Hora",
    eu: "",
    gl: "",
    pt: "Tempo",
    fr: "Heure",
    it: "",
    de: "",
  },
  state: {
    en: "State",
    nl: "Status",
    es: "Estado",
    ca: "Estat",
    eu: "",
    gl: "",
    pt: "Estado",
    fr: "État",
    it: "",
    de: "",
  },
  hideOfflineAgents: {
    en: "Hide offline agents",
    nl: "Offline medewerkers verbergen",
    es: "Ocultar agentes desconectados",
    ca: "Amagar agents desconectats",
    eu: "",
    gl: "",
    pt: "Ocultar os agentes offline",
    fr: "Masquer les agents déconnectés",
    it: "",
    de: "",
  },
  hideMeText: {
    en: "Hide me",
    nl: "Mij verbergen",
    es: "Ocultar mi extensión",
    ca: "Amagar la meva extensió",
    eu: "",
    gl: "",
    pt: "Ocultar minha extensión",
    fr: "Masquer mon extension",
    it: "",
    de: "",
  },
  expandAllText: {
    en: "Expand all",
    nl: "Alles uitvouwen",
    es: "Mostrar todos",
    ca: "Desplega-ho tot",
    eu: "",
    gl: "",
    pt: "Mostrar todos",
    fr: "Tout développer",
    it: "",
    de: "",
  },
  collapseAllText: {
    en: "Collapse all",
    nl: "Alles samenvouwen",
    es: "Cerrar todos",
    ca: "Replega-ho tot",
    eu: "",
    gl: "",
    pt: "Fechar todos",
    fr: "Tout réduire",
    it: "",
    de: "",
  },
  extensionText: {
    en: "Extension",
    nl: "Toestel",
    es: "Extensión",
    ca: "Extensió",
    eu: "",
    gl: "",
    pt: "Extensão",
    fr: "Extension",
    it: "",
    de: "",
  },
  noServiceToSupervise: {
    en: "You do not supervise any service",
    nl: "U hebt geen supervisie over een service",
    es: "No estás supervisando ningún servicio",
    ca: "No estàs supervisant cap servei",
    eu: "",
    gl: "",
    pt: "Não estás supervisionando nenhum serviço",
    fr: "Vous ne supervisez aucun service",
    it: "",
    de: "",
  },
  noAgentsInService: {
    en: "There are no agents in your services",
    nl: "Er zijn geen medewerkers in uw services",
    es: "No hay agentes en tus servicios",
    ca: "No hi ha agents en els teus serveis",
    eu: "",
    gl: "",
    pt: "Não há agentes nos teus serviços",
    fr: "Aucun agent dans votre service",
    it: "",
    de: "",
  },
  noQueuedCallsNow: {
    en: "There are no calls in queue at the moment",
    nl: "Er bevinden zich momenteel geen oproepen in de wachtrij",
    es: "No hay llamadas en cola en el momento",
    ca: "No hi ha trucades en cua en el moment",
    eu: "",
    gl: "",
    pt: "Não há chamadas em espera no momento",
    fr: "Aucun appel en attente pour le moment",
    it: "",
    de: "",
  },
  commonErrorText: {
    en: "Ops! Something went wrong. Please try again in a few minutes and if the problem persists, contact our support team",
    nl: "Oeps! Er is iets misgegaan. Probeer het over enkele minuten opnieuw en neem contact op met ons supportteam als het probleem zich blijft voordoen.",
    es: "¡Ops! Algo no ha ido bien. Por favor vuelve a intentarlo en algunos minutos y si el problema persiste, contacta con nuestro equipo de soporte",
    ca: "Ops! Alguna cosa no ha anat bé. Si us plau, torna a intentar-ho en alguns minuts i si el problema persisteix, contacta amb el nostre equip de suport",
    eu: "",
    gl: "",
    pt: "Ops! Algo não há foi bem. Por favor tente outra vez em alguns minutos e se o problema continua, contacte com nossa equipa de suporte",
    fr: "Oups! Quelque n'a pas fonctionné. S'il vous plaît réessayez dans quelques minutes et si le problème persiste, contactez notre équipe de soutien",
    it: "",
    de: "",
  },
  allFieldsRequired: {
    en: "Please enter the mandatory fields",
    nl: "Voer de verplichte velden in",
    es: "Por favor, rellena los campos obligatorios",
    ca: "Si us plau, omple els camps obligatoris",
    eu: "",
    gl: "",
    pt: "Por favor preencha os campos obligatórios",
    fr: "S'il vous plaît, remplissez les champs obligatoires",
    it: "",
    de: "",
  },
  emailInvalid: {
    en: "Please enter a valid e-mail",
    nl: "Voer een geldig e-mailadres in",
    es: "Por favor introduce un e-mail válido",
    ca: "Si us plau, introdueix un e-mail vàlid",
    eu: "",
    gl: "",
    pt: "Por favor, introduza um e-mail válido",
    fr: "S'il vous plaît, introduisez un mail valide",
    it: "",
    de: "",
  },
  callAvailable: {
    en: "Available for calls",
    nl: "Beschikbaar voor oproepen",
    es: "Disponible para llamadas",
    ca: "Disponible per a trucades",
    eu: "",
    gl: "",
    pt: "Disponível para chamadas",
    fr: "Disponible pour des appels",
    it: "",
    de: "",
  },
  callUnavailable: {
    en: "Unavailable for calls",
    nl: "Niet beschikbaar voor oproepen",
    es: "No disponible para llamadas",
    ca: "No disponible per a trucades",
    eu: "",
    gl: "",
    pt: "Não disponível para chamadas",
    fr: "Indisponible pour des appels",
    it: "",
    de: "",
  },
  sameAgent: {
    en: "Schedule to the same agent",
    nl: "Plannen voor dezelfde medewerker",
    es: "Programar para el mismo agente",
    ca: "Programar pel mateix agent",
    eu: "",
    gl: "",
    pt: "Programar para el mesmo agente",
    fr: "Programmer pour le même agent",
    it: "",
    de: "",
  },
  available: {
    en: "Available",
    nl: "Beschikbaar",
    es: "Disponible",
    ca: "Disponible",
    eu: "",
    gl: "",
    pt: "Disponivel",
    fr: "Disponible",
    it: "",
    de: "",
  },
  unavailable: {
    en: "Unavailable",
    nl: "Niet beschikbaar",
    es: "No disponible",
    ca: "No disponible",
    eu: "",
    gl: "",
    pt: "Não disponível",
    fr: "Indisponible",
    it: "",
    de: "",
  },
  onCall: {
    en: "On call",
    nl: "In gesprek",
    es: "Hablando",
    ca: "Parlant",
    eu: "",
    gl: "",
    pt: "Falando",
    fr: "En train de parler",
    it: "",
    de: "",
  },
  reason: {
    en: "Reason",
    nl: "Reden",
    es: "Motivo",
    ca: "Motiu",
    eu: "",
    gl: "",
    pt: "Motivo",
    fr: "Motif",
    it: "",
    de: "",
  },
  apply: {
    en: "Apply",
    nl: "Toepassen",
    es: "Aplicar",
    ca: "Aplicar",
    eu: "",
    gl: "",
    pt: "Aplicar",
    fr: "Appliquer",
    it: "",
    de: "",
  },
  loading: {
    en: "Loading...",
    nl: "Laden…",
    es: "Cargando...",
    ca: "Carregant...",
    eu: "",
    gl: "",
    pt: "Carregando...",
    fr: "En charge...",
    it: "",
    de: "",
  },
  callFailed: {
    en: "Ops! There has been an error making the call. Make sure your phone is connected and is able to make calls. If the error persists, please contact our support team.",
    nl: "Oeps! Er is een fout opgetreden tijdens het uitvoeren van de oproep. Controleer of uw telefoon verbonden en in staat is om oproepen uit te voeren. Neem contact op met ons supportteam als de fout zich blijft voordoen.",
    es: "¡Ops! Se ha producido un error al realizar la llamada. Asegúrate de que el teléfono está conectado y puede realizar llamadas. Si el error persiste, por favor contacta con nuestro equipo de soporte.",
    ca: "Ops! S'ha produït un error al realitzar la trucada. Assegura't de que el telèfon està connectat i pot realitzar trucades. Si l'error persisteix, si us plau contacta amb l'equip de suport.",
    eu: "",
    gl: "",
    pt: "Ops! Houve um erro fazendo esta chamada. Verifique se seu phone está conectado e é capaz de fazer chamadas. Se o erro persiste, por favor contacte com nossa equipa de suporte.",
    fr: "Oups! Un erreur vient de se produire en réalisant l'appel. Assurez-vous que le téléphone est connecté et peut réaliser des appels. Si l'erreur persiste, s'il vous plaît contactez notre équipe de soutien.",
    it: "",
    de: "",
  },
  noServiceFound: {
    en: "No service found",
    nl: "Geen service gevonden",
    es: "No se ha encontrado el servicio",
    ca: "No s'ha trobat el servei",
    eu: "",
    gl: "",
    pt: "Nenhum serviço encontrado",
    fr: "Service non trouvé",
    it: "",
    de: "",
  },
  // All search boxes
  search: {
    en: "Search",
    nl: "Zoeken",
    es: "Buscar",
    ca: "Cercar",
    eu: "",
    gl: "",
    pt: "Procurar",
    fr: "Chercher",
    it: "",
    de: "",
  },
  // Swtich buttons
  yes: {
    en: "Yes",
    nl: "Ja",
    es: "Sí",
    ca: "Sí",
    eu: "",
    gl: "",
    pt: "Sim",
    fr: "Oui",
    it: "",
    de: "",
  },
  no: {
    en: "No",
    nl: "Nee",
    es: "No",
    ca: "No",
    eu: "",
    gl: "",
    pt: "Não",
    fr: "Non",
    it: "",
    de: "",
  },
  allAvailable: {
    en: "Set available in all services",
    nl: "Als beschikbaar instellen in alle services",
    es: "Ponerse disponible en todos los servicios",
    ca: "Posar-se disponible en tots els serveis",
    eu: "",
    gl: "",
    pt: "Ficar disponível em todos os serviços",
    fr: "Se rendre disponible dans tous les services",
    it: "",
    de: "",
  },
  allUnavailable: {
    en: "Set unavailable in all services",
    nl: "Als niet-beschikbaar instellen in alle services",
    es: "Ponerse no disponible en todos los servicios",
    ca: "Posar-se no disponible en tots els serveis",
    eu: "",
    gl: "",
    pt: "Ficar não disponível em todos os serviços",
    fr: "Se rendre indisponible dans tous les services",
    it: "",
    de: "",
  },
  incoming_calls: {
    // Section name
    en: "Incoming calls",
    nl: "Inkomende oproepen",
    es: "Llamadas entrantes",
    ca: "Trucades entrants",
    eu: "",
    gl: "",
    pt: "Chamadas entrantes",
    fr: "Appels entrants",
    it: "",
    de: "",
  },
  calls_in_queue: {
    // When there are no call in queue
    en: "Queued calls",
    nl: "Oproepen in wachtrij",
    es: "Llamadas en cola",
    ca: "Trucades en cua",
    eu: "",
    gl: "",
    pt: "Chamadas en espera",
    fr: "Appels en attente",
    it: "",
    de: "",
  },
  autodialer: {
    en: "Auto dialer",
    nl: "Automatische kiesfunctie", // Setcion's name
    es: "Automarcador",
    ca: "Automarcador",
    eu: "",
    gl: "",
    pt: "Marcador automático",
    fr: "Automarqueur",
    it: "",
    de: "",
  },
  web_phone: {
    en: "Web phone",
    nl: "Web telefoon",
    es: "Web phone",
    ca: "Web phone",
    eu: "",
    gl: "",
    pt: "Web phone",
    fr: "Web phone",
    it: "",
    de: "",
  },
  agent: {
    en: "Agent",
    nl: "Medewerker",
    es: "Agente",
    ca: "Agent",
    eu: "",
    gl: "",
    pt: "Agente",
    fr: "Agent",
    it: "",
    de: "",
  },
  // rescheduleCall error
  rescheduleCallError: {
    en: "The selected date and time has already passed, please select a valid date and time to schedule the call",
    nl: "De geselecteerde datum en tijd zijn al verstreken. Selecteer een geldige datum en tijd om de oproep te plannen",
    es: "La fecha y hora seleccionada ya han pasado, por favor selecciona una fecha y hora válida para programar la llamada",
    ca: "La data i hora seleccionada ja han passat, si us plau selecciona una data i hora vàlida per programar la trucada",
    eu: "",
    gl: "",
    pt: "A data e hora selecionada já passaram, por favor selecione uma data e hora válida para programar a chamada.",
    fr: "La date et l'heure sélectionnée sont déjà passées, s'il vous plaît sélectionnez une date et une heure valide pour programmer l'appel.",
    it: "",
    de: "",
  },
  onlyNumbers: {
    en: "The phone number should be numeric",
    nl: "Het telefoonnummer moet numeriek zijn",
    es: "El número de teléfono debe ser numérico",
    ca: "EL número de telèfon ha de ser numèric",
    eu: "",
    gl: "",
    pt: "O número do telefone deve ser numérico",
    fr: "Le numéro de téléphone doit être numérique",
    it: "",
    de: "",
  },
  noOptionSelected: {
    en: "Please select a business outcome",
    nl: "Selecteer een zakelijk resultaat",
    es: "Por favor selecciona un final de negocio",
    ca: "Si us plau selecciona un final de negoci",
    eu: "",
    gl: "",
    pt: "Por favor selecione um final de negócio",
    fr: "S'il vous plaît sélectionner une fin de négociation",
    it: "",
    de: "",
  },
  noneAssigned: {
    en: "This service does not have any business outcome assigned to it. Please contact your supervisor.",
    nl: "Aan deze service is geen zakelijk resultaat toegewezen. Neem contact op met uw supervisor.",
    es: "Este servicio no tiene ningún final de negocio asignado. Por favor contacta con tu supervisor.",
    ca: "Aquest servei no té cap final de negoci assignat. Si us plau, contacta amb el teu supervisor.",
    eu: "",
    gl: "",
    pt: "Este serviço não tem nenhum final de negócio associado a ele. Por favor contacte o seu supervisor.",
    fr: "Ce service n'a aucune négociation attribuée. S'il vous plaît, contactez votre superviseur.",
    it: "",
    de: "",
  },
  noOutgoingService: {
    en: "You are not working on any service. Please contact your supervisor.",
    nl: "U werkt niet aan een service. Neem contact op met uw supervisor.",
    es: "No estás trabajando en ningún servicio. Por favor contacta con tu supervisor.",
    ca: "No estàs treballant en cap servei. Si us plau, contacta amb el teu supervisor.",
    eu: "",
    gl: "",
    pt: "Não estás trabalhando em nenhum serviço. Por favor contacte com seu supervisor.",
    fr: "Il ne travaille dans aucun service. S'il vous plaît, contactez votre superviseur.",
    it: "",
    de: "",
  },
  switchScreen: {
    en: "Switch screen",
    nl: "Scherm verwisselen",
    es: "Cambiar visualización",
    ca: "Canviar visualització",
    eu: "",
    gl: "",
    pt: "Switch screen",
    fr: "Changer de visualisation",
    it: "",
    de: "",
  },
  // error messages
  authError: {
    en: "Error while authenticating.",
    nl: "Fout tijdens verificatie.",
    es: "Error al autenticar.",
    ca: "Error al autenticar.",
    eu: "",
    gl: "",
    pt: "Error while authenticating.",
    fr: "Erreur d'authentification",
    it: "",
    de: "",
  },

  //Offline alert
  offlineAlert: {
    en: "Ops! Seems you are offline, please check your Internet connection...",
    nl: "Oeps! Het lijkt erop dat u offline bent. Controleer uw internetverbinding…",
    es: "Ops! Parece ser que no estás conectado a Internet, por favor verifique tu conexión...",
    ca: "Ops! Sembla ser que no estàs connectat a Internet, si us plau verifiqui la teva connexió...",
    eu: "",
    gl: "",
    pt: "Ops! Parece que não estás conectado a Internet, por favor verifique sua conexão...",
    fr: "Ops! Il semble que vous n’êtes pas connecté à Internet, veuillez vérifier votre connexion...",
    it: "",
    de: "",
  },

  //Weekdays and months
  mondayMin: {
    en: "Mo",
    nl: "Ma",
    es: "Lu",
    ca: "Dl",
    eu: "",
    gl: "",
    pt: "Se",
    fr: "Lu",
    it: "",
    de: "",
  },
  tuesdayMin: {
    en: "Tu",
    nl: "Di",
    es: "Ma",
    ca: "Dt",
    eu: "",
    gl: "",
    pt: "Te",
    fr: "Ma",
    it: "",
    de: "",
  },
  wednesdayMin: {
    en: "We",
    nl: "Wo",
    es: "Mi",
    ca: "Dc",
    eu: "",
    gl: "",
    pt: "Qu",
    fr: "Me",
    it: "",
    de: "",
  },
  thursdayMin: {
    en: "Th",
    nl: "Do",
    es: "Ju",
    ca: "Dj",
    eu: "",
    gl: "",
    pt: "Qu",
    fr: "Je",
    it: "",
    de: "",
  },
  fridayMin: {
    en: "Fr",
    nl: "Vr",
    es: "Vi",
    ca: "Dv",
    eu: "",
    gl: "",
    pt: "Se",
    fr: "Ve",
    it: "",
    de: "",
  },
  saturdayMin: {
    en: "Sa",
    nl: "Za",
    es: "Sá",
    ca: "Ds",
    eu: "",
    gl: "",
    pt: "Sá",
    fr: "Sa",
    it: "",
    de: "",
  },
  sundayMin: {
    en: "Su",
    nl: "Zo",
    es: "Do",
    ca: "Dg",
    eu: "",
    gl: "",
    pt: "Do",
    fr: "Di",
    it: "",
    de: "",
  },
  mondayShort: {
    en: "Mon",
    nl: "Maa",
    es: "Lun",
    ca: "Dl",
    eu: "",
    gl: "",
    pt: "Seg",
    fr: "Lun",
    it: "",
    de: "",
  },
  tuesdayShort: {
    en: "Tue",
    nl: "Din",
    es: "Mar",
    ca: "Dt",
    eu: "",
    gl: "",
    pt: "Ter",
    fr: "Mar",
    it: "",
    de: "",
  },
  wednesdayShort: {
    en: "Wen",
    nl: "Woe",
    es: "Mie",
    ca: "Dc",
    eu: "",
    gl: "",
    pt: "Qua",
    fr: "Mer",
    it: "",
    de: "",
  },
  thursdayShort: {
    en: "Thr",
    nl: "Don",
    es: "Jue",
    ca: "Dj",
    eu: "",
    gl: "",
    pt: "Qui",
    fr: "Jeu",
    it: "",
    de: "",
  },
  fridayShort: {
    en: "Fri",
    nl: "Vrij",
    es: "Vie",
    ca: "Dv",
    eu: "",
    gl: "",
    pt: "Sex",
    fr: "Ven",
    it: "",
    de: "",
  },
  saturdayShort: {
    en: "Sat",
    nl: "Zat",
    es: "Sáb",
    ca: "Ds",
    eu: "",
    gl: "",
    pt: "Sáb",
    fr: "Sam",
    it: "",
    de: "",
  },
  sundayShort: {
    en: "Sun",
    nl: "Zon",
    es: "Dom",
    ca: "Dg",
    eu: "",
    gl: "",
    pt: "Dom",
    fr: "Dim",
    it: "",
    de: "",
  },
  monday: {
    en: "Monday",
    nl: "Maandag",
    es: "Lunes",
    ca: "Dilluns",
    eu: "",
    gl: "",
    pt: "Segunda",
    fr: "Lundi",
    it: "",
    de: "",
  },
  tuesday: {
    en: "Tuesday",
    nl: "Dinsdag",
    es: "Martes",
    ca: "Dimarts",
    eu: "",
    gl: "",
    pt: "Terça",
    fr: "Mardi",
    it: "",
    de: "",
  },
  wednesday: {
    en: "Wednesday",
    nl: "Woensdag",
    es: "Miércoles",
    ca: "Dimecres",
    eu: "",
    gl: "",
    pt: "Quarta",
    fr: "Mercredi",
    it: "",
    de: "",
  },
  thursday: {
    en: "Thursday",
    nl: "Donderdag",
    es: "Jueves",
    ca: "Dijous",
    eu: "",
    gl: "",
    pt: "Quinta",
    fr: "Jeudi",
    it: "",
    de: "",
  },
  friday: {
    en: "Friday",
    nl: "Vrijdag",
    es: "Viernes",
    ca: "Divendres",
    eu: "",
    gl: "",
    pt: "Sexta",
    fr: "Vendredi",
    it: "",
    de: "",
  },
  saturday: {
    en: "Saturday",
    nl: "Zaterdag",
    es: "Sábado",
    ca: "Dissabte",
    eu: "",
    gl: "",
    pt: "Sábado",
    fr: "Samedi",
    it: "",
    de: "",
  },
  sunday: {
    en: "Sunday",
    nl: "Zondag",
    es: "Domingo",
    ca: "Diumenge",
    eu: "",
    gl: "",
    pt: "Domingo",
    fr: "Dimanche",
    it: "",
    de: "",
  },
  januaryShort: {
    en: "Jan",
    nl: "Jan",
    es: "Ene",
    ca: "Gen",
    eu: "",
    gl: "",
    pt: "Jan",
    fr: "Jan",
    it: "",
    de: "",
  },
  februaryShort: {
    en: "Feb",
    nl: "Feb",
    es: "Feb",
    ca: "Feb",
    eu: "",
    gl: "",
    pt: "Fev",
    fr: "Fév",
    it: "",
    de: "",
  },
  marchShort: {
    en: "Mar",
    nl: "Mrt",
    es: "Mar",
    ca: "Mar",
    eu: "",
    gl: "",
    pt: "Mar",
    fr: "Mar",
    it: "",
    de: "",
  },
  aprilShort: {
    en: "Apr",
    nl: "Apr",
    es: "Abr",
    ca: "Abr",
    eu: "",
    gl: "",
    pt: "Abr",
    fr: "Avr",
    it: "",
    de: "",
  },
  mayShort: {
    en: "May",
    nl: "Mei",
    es: "May",
    ca: "Mai",
    eu: "",
    gl: "",
    pt: "Mai",
    fr: "Mai",
    it: "",
    de: "",
  },
  juneShort: {
    en: "Jun",
    nl: "Jun",
    es: "Jun",
    ca: "Jun",
    eu: "",
    gl: "",
    pt: "Jun",
    fr: "Jui",
    it: "",
    de: "",
  },
  julyShort: {
    en: "Jul",
    nl: "Jul",
    es: "Jul",
    ca: "Jul",
    eu: "",
    gl: "",
    pt: "Jul",
    fr: "Jui",
    it: "",
    de: "",
  },
  augustShort: {
    en: "Aug",
    nl: "Aug",
    es: "Ago",
    ca: "Ago",
    eu: "",
    gl: "",
    pt: "Ago",
    fr: "Aoû",
    it: "",
    de: "",
  },
  septemberShort: {
    en: "Sep",
    nl: "Sep",
    es: "Sep",
    ca: "Set",
    eu: "",
    gl: "",
    pt: "Set",
    fr: "Sep",
    it: "",
    de: "",
  },
  octoberShort: {
    en: "Oct",
    nl: "Okt",
    es: "Oct",
    ca: "Oct",
    eu: "",
    gl: "",
    pt: "Out",
    fr: "Oct",
    it: "",
    de: "",
  },
  novemberShort: {
    en: "Nov",
    nl: "Nov",
    es: "Nov",
    ca: "Nov",
    eu: "",
    gl: "",
    pt: "Nov",
    fr: "Nov",
    it: "",
    de: "",
  },
  decemberShort: {
    en: "Dec",
    nl: "Dec",
    es: "Dic",
    ca: "Des",
    eu: "",
    gl: "",
    pt: "Dez",
    fr: "Déc",
    it: "",
    de: "",
  },
  january: {
    en: "January",
    nl: "Januari",
    es: "Enero",
    ca: "Gener",
    eu: "",
    gl: "",
    pt: "Janeiro",
    fr: "Janvier",
    it: "",
    de: "",
  },
  february: {
    en: "February",
    nl: "Februari",
    es: "Febrero",
    ca: "Febrer",
    eu: "",
    gl: "",
    pt: "Fevereiro",
    fr: "Février",
    it: "",
    de: "",
  },
  march: {
    en: "March",
    nl: "Maart",
    es: "Marzo",
    ca: "Març",
    eu: "",
    gl: "",
    pt: "Março",
    fr: "Mars",
    it: "",
    de: "",
  },
  april: {
    en: "April",
    nl: "April",
    es: "Abril",
    ca: "Abril",
    eu: "",
    gl: "",
    pt: "Abril",
    fr: "Avril",
    it: "",
    de: "",
  },
  may: {
    en: "May",
    nl: "Mei",
    es: "Mayo",
    ca: "Maig",
    eu: "",
    gl: "",
    pt: "Maio",
    fr: "Mai",
    it: "",
    de: "",
  },
  june: {
    en: "June",
    nl: "Juni",
    es: "Junio",
    ca: "Juny",
    eu: "",
    gl: "",
    pt: "Junio",
    fr: "Juin",
    it: "",
    de: "",
  },
  july: {
    en: "July",
    nl: "Juli",
    es: "Julio",
    ca: "Juliol",
    eu: "",
    gl: "",
    pt: "Julho",
    fr: "Juillet",
    it: "",
    de: "",
  },
  august: {
    en: "August",
    nl: "Augustus",
    es: "Agosto",
    ca: "Agost",
    eu: "",
    gl: "",
    pt: "Agosto",
    fr: "Août",
    it: "",
    de: "",
  },
  september: {
    en: "September",
    nl: "September",
    es: "Septiembre",
    ca: "Setembre",
    eu: "",
    gl: "",
    pt: "Setembro",
    fr: "Septembre",
    it: "",
    de: "",
  },
  october: {
    en: "October",
    nl: "Oktober",
    es: "Octubre",
    ca: "Octubre",
    eu: "",
    gl: "",
    pt: "Outubro",
    fr: "Octobre",
    it: "",
    de: "",
  },
  november: {
    en: "November",
    nl: "November",
    es: "Noviembre",
    ca: "Novembre",
    eu: "",
    gl: "",
    pt: "Novembro",
    fr: "Novembre",
    it: "",
    de: "",
  },
  december: {
    en: "December",
    nl: "December",
    es: "Diciembre",
    ca: "Desembre",
    eu: "",
    gl: "",
    pt: "Dezembro",
    fr: "Décembre",
    it: "",
    de: "",
  },

  /* BusinessOutcomeAlertModal */

  businessOutcome_alert_header: {
    en: "Business outcome mandatory",
    nl: "Zakelijk resultaat verplicht",
    es: "Final de llamada obligatorio",
    ca: "Final de trucada obligatori",
    eu: "",
    gl: "",
    pt: "Final de chamada obrigatório",
    fr: "Fin d'appel obligatoire",
    it: "",
    de: "",
  },
  businessOutcome_alert_text: {
    en: "Do you want to close the tab without setting a business outcome? If so, the service manager will be informed.",
    nl: "Wilt u het tabblad sluiten zonder een zakelijk resultaat in te stellen? Als dat het geval is, wordt de servicemanager op de hoogte gesteld.",
    es: "Seguro que quieres cerrar la pestaña sin finalizar? En caso afirmativo, el supervisor del servicio será informado.",
    ca: "Segur que vols tancar la pestanya sense finalitzar? En cas afirmatiu, el supervisor del servei serà informat.",
    eu: "",
    gl: "",
    pt: "Tem certeza que pretende fechar a aba sem finalizar a chamada? Em caso afirmativo, o supervisor será informado.",
    fr: "Voulez-vous vraiment fermer l'onglet avant de terminer? Dans ce cas, le superviseur du service sera averti.",
    it: "",
    de: "",
  },
  close_tab: {
    en: "Close tab",
    nl: "Tabblad sluiten",
    es: "Cerrar pestaña",
    ca: "Tancat pestanya",
    eu: "",
    gl: "",
    pt: "Fechar aba",
    fr: "Fermer l'onglet",
    it: "",
    de: "",
  },
  disableOutGoingCallMessage: {
    en: "This call is not related to any service, thus, it cannot have a business outcome",
    nl: "Deze oproep heeft geen betrekking op een service en kan daarom geen zakelijk resultaat hebben",
    es: "Esta llamada no está asignada a ningún servicio así que no es posible poner un final de negocio",
    pt: "Esta chamada não está relacionada a nenhum serviço assim que nao é possivel colocar um final de negócio",
    ca: "Aquesta trucada no està assignada a cap servei així que no es pot posar-li un final de negoci",
    fr: "Cet appel n'est lié à aucun service, il ne peut donc pas avoir de résultat commercial",
  },
  changeApplyInNextLogin: {
    en: "This change will apply in your next login",
    nl: "Deze wijziging wordt toegepast wanneer u zich de volgende keer aanmeldt",
    es: "Este cambio se aplicará en tu próximo login",
    pt: "Esta configuração se aplicará no seu próximo login",
    ca: "Aquest canvi s'aplicarà en el teu proper login",
    fr: "",
  },
  onGoingCall: {
    en: " Ongoing call",
    nl: " Actieve oproep",
    es: "Llamada en curso",
    pt: "Chamada em andamento",
    ca: "Trucada en curs",
    fr: "Appel en cours",
  },
  listen: {
    en: "Listen",
    nl: "Luisteren",
    es: "Escuchar",
    pt: "Escutar",
    ca: "Escoltar",
    fr: "Écouter",
  },
  advice: {
    en: "Advise",
    nl: "Adviseren",
    es: "Aconsejar",
    pt: "Conselho",
    ca: "Aconsellar",
    fr: "Conseiller",
  },
  hangUp: {
    en: "Hang up",
    nl: "Ophangen",
    es: "Colgar",
    pt: "Desligar",
    ca: "Penjar",
    fr: "Raccrocher",
  },
  incomingCall: {
    en: "Incoming Call",
    nl: "Inkomende oproep",
    es: "Llamada entrante",
    pt: "Chamada entrantes",
    ca: "Trucada entrants",
    fr: "Appel entrant",
  },
  outgoingCall: {
    en: "Outgoing Call",
    nl: "Uitgaande oproep",
    es: "Llamadas saliente",
    pt: "chamada de saída",
    ca: "Trucada sortint",
    fr: "Appel sortant",
  },
  noCall: {
    en: "No Calls Available",
    nl: "Geen oproepen beschikbaar",
    es: "No Calls Available",
    pt: "No Calls Available",
    ca: "No Calls Available",
    fr: "No Calls Available",
  },
  licenseError: {
    en: "Invalid license for contact center",
    es: "Licencia no valida para contact center",
    pt: "Licença inválida para contact center",
    ca: "Llicència no calida per contact center",
    fr: "Licença inválida para contact center",
  },
  selectAudio: {
    en: "Select audio devices",
    nl: "Selecteer audiapparaten",
    es: "Selección de dispositivos de audio",
    pt: "Selecionar dispositivos de áudio",
    ca: "Selecciona dispositius d'àudio",
    fr: "Sélectionner les périphériques audio",
  },
  ringOutput:{
    en: "Ring output",
    nl: "Beluitvoer",
    es: "Salida de timbre",
    pt: "Saída de toque",
    ca: "Sortida de timbre",
    fr: "Sortie de sonnerie"
  },
  voiceOutput:{
    en: "Conversation output",
    nl: "Stemuitvoer",
    es: "Salida de conversación",
    pt: "Saída de conversa",
    ca: "Sortida de conversació",
    fr: "Sortie de conversation"
  },
  audioSettings: {
    en: "Audio settings",
    nl: "Audio-instellingen",
    es: "Configuración de audio",
    pt: "Configurações de áudio",
    ca: "Configuració d'àudio",
    fr: "Paramètres audio"
  },
  warningAudioSettingsInvalidMessage: {
    en: "The audio settings are invalid for this computer. Please access the audio settings section and select a correct setting.",
    nl: "De audio-instellingen zijn ongeldig voor deze computer. Ga naar het gedeelte met audio-instellingen en selecteer een juiste instelling.",
    es: "La configuración de audio es inválida para este ordenador. Por favor, acceda a la sección de configuración de audio y seleccione una configuración correcta.",
    ca: "La configuració d'audio és invàlida per a aquest ordinador. Si us plau, accedeix a la secció de configuració d'audio i seleccioni una configuració correcta.",
    eu: "",
    gl: "",
    pt: "As configurações de áudio são inválidas para este computador. Acesse a seção de configurações de áudio e selecione uma configuração correta.",
    fr: "Les paramètres audio ne sont pas valides pour cet ordinateur. Veuillez accéder à la section des paramètres audio et sélectionner un paramètre correct.",
    it: "",
    de: ""
  },
  whisperNotificationTitle: {
    en: "Whisper call",
    nl: "Whisper call",
    es: "Llamada Whisper",
    pt: "Whisper call",
    ca: "Trucada Whisper",
    fr: "Whisper call"
  },
  whisperSpyNotification: {
    en: "Spy call ongoing",
    nl: "Spy call ongoing",
    es: "Llamada Spy en curso",
    pt: "Spy call ongoing",
    ca: "Trucada Spy en curs",
    fr: "Spy call ongoing"
  },
  whisperAdviserNotification: {
    en: "Adviser call ongoing",
    nl: "Adviser call ongoing",
    es: "Llamada Adviser en curso",
    pt: "Adviser call ongoing",
    ca: "Trucada Adviser en curs",
    fr: "Adviser call ongoing"
  },
    pending: {
      en: "Do you want to activate Multi-Factor Authentication (MFA) now? The process will only take two minutes.",
      nl: "Deseja ativar agora a autenticação de duplo fator (MFA)? O processo demorará apenas dois minutos.",
      es: "¿Quieres activar ahora el doble factor de autenticación (MFA)? El proceso solo te llevará dos minutos.",
      pt: "Wilt u de tweefactorauthenticatie (MFA) nu activeren? Het proces duurt slechts twee minuten.",
      ca: "¿Vols activar ara el doble factor d'autenticació (MFA)? El procés només et portarà dos minuts.",
      fr: "Voulez-vous activer l'authentification à double facteur (MFA) maintenant ? Le processus ne vous prendra que deux minutes."
    },
    verify: {
      en: "Please review and confirm if the displayed email is correct. Otherwise, please enter the correct email address.",
      nl: "Controleer je e-mail om het verificatieproces te voltooien.",
      es: "Revisa y confirma si el email que te mostramos es correcto. En caso contrario, introduce la dirección de email correcta.",
      pt: "Verifique o seu e-mail para concluir o processo de verificação.",
      ca: " Revisa i confirma si l'email que et mostrem és correcte. En cas contrari, introdueix l'adreça d'email correcta.",
      fr: "Vérifiez votre e-mail pour terminer le processus de vérification."
    },
    check_email_verify: {
      en: "Check your email to complete the verification process.",
      nl: "Controleer uw e-mail om door te gaan met de activering van de tweefactorauthenticatie (MFA). Als u nu annuleert, geen zorgen: u kunt het later hervatten.",
      es: "Revisa tu correo para completar el proceso de verificación.",
      pt: "Verifique o seu email para continuar com a ativação do duplo fator (MFA). Se cancelar agora, não se preocupe: poderá retomar mais tarde.",
      ca: "Revisa el teu correu per completar el procés de verificació.",
      fr: "Vérifiez votre email pour poursuivre l'activation du double facteur (MFA). Si vous annulez maintenant, ne vous inquiétez pas : vous pourrez reprendre plus tard."
    },
    support: {
      en: "We encountered a problem registering your email. You can access the agent without issues; a support technician will contact you as soon as possible. Thank you very much.",
      nl: "Er is een probleem opgetreden bij het registreren van uw e-mailadres. U kunt zonder problemen toegang krijgen tot de agent; een supporttechnicus zal zo snel mogelijk contact met u opnemen. Hartelijk dank.",
      es: "Hemos tenido un problema al registrar tu email. Puedes acceder al agente sin inconvenientes; un técnico de soporte se pondrá en contacto contigo lo antes posible. Muchas gracias.",
      pt: "Tivemos um problema ao registar o seu email. Pode aceder ao agente sem inconvenientes; um técnico de suporte entrará em contacto consigo o mais brevemente possível. Muito obrigado.",
      ca: "Hem tingut un problema en registrar el teu email. Pots accedir a l'agent sense inconvenients; un tècnic de suport es posarà en contacte amb tu al més aviat possible. Moltes gràcies.",
      fr: "Nous avons rencontré un problème lors de l'enregistrement de votre email. Vous pouvez accéder à l'agent sans inconvénient ; un technicien support vous contactera dans les plus brefs délais. Merci beaucoup."
    },
    email: {
      en: "Check your email to complete MFA activation or resend the email.",
      nl: "Controleer je e-mail om de MFA-activering te voltooien of stuur de e-mail opnieuw.",
      es: "Revisa tu email para finalizar la activación del MFA o reenvía el correo.",
      pt: "Verifique o seu e-mail para concluir a ativação do MFA ou reenvie o e-mail.",
      ca: " Comprova el teu email per finalitzar l’activació del MFA o reenvia l’email de nou.",
      fr: "Vérifiez votre e-mail pour finaliser l'activation du MFA ou renvoyez l'e-mail."
    },
    mfa_title:{
      en: "Enable MFA",
      nl: "MFA activeren",
      es: "Habilitar MFA",
      pt: "Ativar MFA",
      ca: "Habilitar l'MFA",
      fr: "Activer le MFA"
    },
    confirm_title:
    {
      en: "Confirm email",
      nl: "E-mail bevestigen",
      es: "Confirmar email",
      pt: "Confirmar e-mail",
      ca: "Confirmar l'email",
      fr: "Confirmer l'e-mail"
    },
    confirm: {
      en: "Confirm",
      nl: "Bevestigen",
      es: "Confirmar",
      pt: "Confirmar",
      ca: "Confirmar",
      fr: "Confirmer"
    },
    new: {
      en: "New",
      nl: "Novo",
      es: "Nuevo",
      pt: "Novo",
      ca: "Nou",
      fr: "Nouveau"
    },
    cancel: {
      en: "Cancel",
      nl: "Annuleren",
      es: "Cancelar",
      pt: "Cancelar",
      ca: "Cancel·lar",
      fr: "Annuler"
    },
    next_step: {
      en: "Next step",
      nl: "Volgende stap",
      es: "Siguiente paso",
      pt: "Passo seguinte",
      ca: "Següent pas",
      fr: "Étape suivante"
    },
    not_now: {
      en: "Not now",
      nl: "Nu niet",
      es: "No ahora",
      pt: "Agora não",
      ca: "Ara no",
      fr: "Pas maintenant"
    },
    later: {
      en: "Finish later",
      nl: "Later afronden",
      es: "Acabar luego",
      pt: "Terminar mais tarde",
      ca: "Acabar més tard",
      fr: "Finir plus tard"
    },
    resend: {
      en: "Resend",
      nl: "Opnieuw verzenden",
      es: "Reenviar",
      pt: "Reenviar",
      ca: "Reenviar",
      fr: "Renvoyer"
    },
    error_email_change: { 
      en: "There was an error changing the email. Would you like to notify support?",
      nl: "Er is een fout opgetreden bij het wijzigen van het e-mailadres. Wilt u de ondersteuning hiervan op de hoogte stellen?",
      es: "Hubo un error al cambiar el correo electrónico. ¿Desea notificar al soporte?",
      pt: "Houve um erro ao alterar o email. Gostaria de notificar o suporte?",
      ca: "Hi ha hagut un error en canviar el correu electrònic. Voleu notificar-ho al suport?",
      fr: "Une erreur s'est produite lors du changement d'email. Souhaitez-vous en informer le support?"
    },
    notify_error_email: {
      en: "notify support",
      nl: "Support benachrichtigen",
      es: "avisar a soporte",
      pt: "avisar o suporte",
      ca: "avisar a suport",
      fr: "contacter le support"
    } ,
    footer_1: {
      en: "Soon, the use of MFA (Multi-Factor Authentication) will be mandatory to access the portal.\n\nIf you do not activate this security measure, your account will be blocked.\n\nAvoid issues and configure MFA as soon as possible.",
      nl: "Binnenkort wordt het gebruik van MFA (Multi-Factor Authenticatie) verplicht om toegang te krijgen tot het portaal.\n\nAls u deze beveiligingsmaatregel niet activeert, wordt uw account geblokkeerd.\n\nVermijd problemen en stel MFA zo snel mogelijk in.",
      es: "Próximamente, el uso de MFA (Autenticación Multifactor) será obligatorio para acceder al portal.\n\nSi no activas esta medida de seguridad, tu cuenta será bloqueada.\n\nEvita incidencias y configura MFA lo antes posible.",
      pt: "Em breve, o uso de MFA (Autenticação Multifator) será obrigatório para aceder ao portal.\n\nSe não ativar esta medida de segurança, a sua conta será bloqueada.\n\nEvite incidências e configure o MFA o mais brevemente possível.",
      ca: "Pròximament, l'ús de MFA (Autenticació Multifactor) serà obligatori per accedir al portal.\n\nSi no actives aquesta mesura de seguretat, el teu compte serà bloquejat.\n\nEvita incidències i configura el MFA el més aviat possible.",
      fr: "Prochainement, l'utilisation de la MFA (Authentification Multifacteur) sera obligatoire pour accéder au portail.\n\nSi vous n'activez pas cette mesure de sécurité, votre compte sera bloqué.\n\nÉvitez les incidents et configurez la MFA dès que possible."
    },
    footer_2: {
      en: " If you cancel now, don't worry: you can resume later.",
      nl: "Als je nu annuleert, maak je geen zorgen: je kunt het later hervatten.",
      es: "Si cancelas ahora, no te preocupes: podrás retomarlo más adelante.",
      pt: "Se cancelar agora, não se preocupe: poderá retomar mais tarde.",
      ca: "Si cancel·les ara, no et preocupis: podràs reprendre-ho més endavant.",
      fr: "Si vous annulez maintenant, ne vous inquiétez pas : vous pourrez reprendre plus tard."
    },
    footer_3: {
      en: "You can continue using the agent without issues.",
      nl: "Je kunt de agent gewoon blijven gebruiken.",
      es: "Puedes seguir utilizando el agente sin inconvenientes.",
      pt: "Pode continuar a utilizar o agente sem problemas.",
      ca: "Pots continuar utilitzant l'agent sense inconvenients.",
      fr: "Vous pouvez continuer à utiliser l'agent sans problème."
    },
    ask_later: {
      en: "Ask me later",
      nl: "Vraag het me later",
      es: "Pregúntame más tarde",
      ca: "Pregunta'm més tard",
      pt: "Pergunte-me mais tarde",
      fr: "Demandez-moi plus tard",
    },
    error_format: {
      en: "The email format is invalid.",
      nl: "Dit e-mailadres heeft geen geldig formaat.",
      es: "Este email no tiene un formato válido.",
      ca: "Aquest email no té un format vàlid.",
      pt: "Este e-mail não tem um formato válido.",
      fr: "Le format de cet e-mail n'est pas valide.",
    },
    error_email_change_part1: {
      en : "The email address you entered is incorrect. Please try again or, if you prefer, click the ",
      nl : "Die eingegebene E-Mail-Adresse ist nicht korrekt. Bitte versuchen Sie es erneut oder klicken Sie auf die Schaltfläche ",
      es : "El email introducido no es correcto. Inténtalo de nuevo o, si lo prefieres, haz clic en el botón ",
      ca : "L'email introduït no és correcte. Torna-ho a provar o, si ho prefereixes, fes clic al botó ",
      pt : "O e-mail introduzido não está correto. Tente novamente ou, se preferir, clique no botão ",
      fr : "L'adresse e-mail saisie est incorrecte. Veuillez réessayer ou, si vous le préférez, cliquez sur le bouton "
    },
    error_email_change_part2: {
      en : " button so they can help you resolve this as soon as possible.",
      nl : ", damit dieser Ihnen so schnell wie möglich helfen kann.",
      es : " y que te ayuden a resolverlo cuanto antes.",
      ca : " i que t'ajudin a resoldre-ho com més aviat millor.",
      pt : " para que o ajudem a resolver o problema o mais breve possível.",
      fr : " afin qu'ils vous aident à résoudre le problème au plus vite."
    },
    notify_support: {
      en : "Notify support",
      nl : "Melden aan support.",
      es : "Notificar al equipo de soporte.",
      ca : "Notificar a l'equip de suport.  ",
      pt : "Notificar a equipa de suporte.",
      fr : "Signaler au support."
    },
    back: {     
      en: "Back",
      nl: "Terug",
      es: "Atrás",
      ca: "Enrere",
      pt: "Voltar",
      fr: "Retour" 
    },
    notified: {
      en: "The support team has been notified.",
      nl: "Het supportteam is op de hoogte gebracht.",
      es: "Se ha notificado al equipo de soporte.",
      ca: "S'ha notificat l'equip de suport.",
      pt: "A equipe de suporte foi notificada.",
      fr: "L'équipe de support a été notifiée.",
    },

};



// WEBPACK FOOTER //
// ./src/translations.js